import React from 'react';

import { LoadingButtonWithTooltip } from '@qality/common-components/src/molecules/LoadingButtonWithTooltip';
import {
  FEATURE_FLAG,
  PREMIUM_FEATURE_TOOLTIP_MESSAGE,
} from '@qality/common-config';
import { Folder } from '@qality/common-model';

import { useTestCaseRepositoryModalsContext } from '../TestCaseRepositoryModalsProvider';

type Props = {
  parentFolder?: Folder;
  children?: React.ReactNode;
};

export function CreateFolderModalButton({
  parentFolder,
  children,
}: Props): JSX.Element {
  const { openCreateFolderModal } = useTestCaseRepositoryModalsContext();

  const handleClick = () => {
    openCreateFolderModal({
      parentFolder,
    });
  };

  const childrenFallback = `Create ${parentFolder ? 'Subfolder' : 'Folder'}`;

  return (
    <LoadingButtonWithTooltip
      loadingButtonProps={{
        onClick: handleClick,
        isDisabled: !FEATURE_FLAG.isPremium,
      }}
      tooltipProps={{
        content: !FEATURE_FLAG.isPremium && PREMIUM_FEATURE_TOOLTIP_MESSAGE,
      }}
    >
      {children ?? childrenFallback}
    </LoadingButtonWithTooltip>
  );
}
